import { render } from "./PdfMenuItem.vue?vue&type=template&id=20113a7e"
import script from "./PdfMenuItem.vue?vue&type=script&lang=js"
export * from "./PdfMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__